// src/modules/app-views/account/pages/Init/decorators/response.js
// *******************************************************************************
// RESPONSE DECORATOR
// Transforms data received from the server before binding to form
// *******************************************************************************

/**
 * Transforms server response before binding to form components
 *
 * @param {Object} ctx - Context object
 * @param {Object} ctx.doc - Single document (used when mapping arrays)
 * @param {Object|Array} ctx.payload - Complete payload from server
 * @param {Object} ctx.summary - Summary data from response
 * @param {String} ctx.url - Request URL
 * @param {String} ctx.method - HTTP method
 * @returns {Object} Transformed data ready for form binding
 */
const decorateResponse = ctx => {
  const { doc } = ctx;

  if (!doc) return doc;

  return doc;
};

// export default decorateResponseMain;
export default decorateResponse;
